import { motion } from "framer-motion";
import { ArrowLeft, BookOpen } from "lucide-react";

const blogs = [
  {
    platform: "رواج الذكية",
    domain: "rawajsmart.com",
    color: "text-[#E5C158]",
    posts: [
      { title: "واتساب بوت وإيميل بوت للشركات السعودية: آلية الاستخدام خطوة بخطوة (دليل 2026)", url: "https://rawajsmart.com/blog/whatsapp-bot-email-bot-how-it-works-saudi" },
      { title: "الحلول الرقمية والتسويق الرقمي للمنشآت الصغيرة والمتوسطة في السعودية 2026", url: "https://rawajsmart.com/blog/digital-marketing-solutions-saudi-smes-2026" },
      { title: "توليد الصور والفيديو بالذكاء الاصطناعي للإعلانات في السعودية: الدليل الكامل 2026", url: "https://rawajsmart.com/blog/ai-image-video-generation-ads-saudi-2026" },
    ],
  },
  {
    platform: "برولانسر",
    domain: "prolancer.sa",
    color: "text-[#38BDF8]",
    posts: [
      { title: "دليل العمل الحر في السعودية: كيف تبدأ وتنجح كمستقل؟", url: "https://prolancer.sa/blog/%D8%A7%D9%84%D8%B9%D9%85%D9%84-%D8%A7%D9%84%D8%AD%D8%B1-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9" },
      { title: "كيف تسعّر خدماتك كمستقل دون بيعها بأقل من قيمتها", url: "https://prolancer.sa/blog/how-to-price-your-services" },
      { title: "وثيقة العمل الحر: ما هي وكيف تصدرها ولماذا تهمّك", url: "https://prolancer.sa/blog/freelance-document-saudi" },
    ],
  },
  {
    platform: "حاسبتنا الذكية",
    domain: "prolancer.app",
    color: "text-[#10B981]",
    posts: [
      { title: "كم سعر تصميم شعار في السعودية؟ 2026", url: "https://prolancer.app/logo-design-pricing-saudi" },
      { title: "كم سعر تصميم موقع إلكتروني في السعودية؟ 2026", url: "https://prolancer.app/website-design-pricing-saudi" },
      { title: "كم تكلفة تطوير متجر إلكتروني في السعودية 2026؟", url: "https://prolancer.app/ecommerce-pricing-saudi" },
    ],
  },
];

export const Blogs = () => (
  <section id="blogs" data-testid="blogs-section" className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14"
      >
        <div className="font-mono-tech text-xs sm:text-sm tracking-[0.25em] text-[#D4AF37] mb-4" dir="ltr">— FROM OUR BLOGS</div>
        <h2 className="font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-[#F8FAFC]" data-testid="blogs-title">
          من مدونات منصاتنا <span className="gold-text">معرفة عملية للسوق السعودي</span>
        </h2>
        <p className="mt-4 max-w-2xl font-body text-base sm:text-lg text-[#94A3B8]">
          مقالات مختارة من مدونات رواج الذكية وبرولانسر وحاسبتنا الذكية — في التسويق والعمل الحر والتسعير.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {blogs.map((b, bi) => (
          <motion.div
            key={b.domain}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay: bi * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="glass-card rounded-3xl p-7 flex flex-col"
            data-testid={`blog-column-${b.domain.replace(/\./g, "-")}`}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-10 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/25 flex items-center justify-center shrink-0">
                <BookOpen size={18} className="text-[#E5C158]" />
              </span>
              <div>
                <div className={`font-display font-bold text-lg ${b.color}`}>{b.platform}</div>
                <div className="font-mono-tech text-xs text-[#94A3B8]" dir="ltr">{b.domain}/blog</div>
              </div>
            </div>
            <ul className="space-y-4 flex-1">
              {b.posts.map((p) => (
                <li key={p.url}>
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`blog-post-${p.url.split("/").pop()}`}
                    className="group flex items-start justify-between gap-3 font-body text-sm leading-relaxed text-[#CBD5E1] hover:text-[#E5C158] transition-colors duration-300"
                  >
                    <span>{p.title}</span>
                    <ArrowLeft size={15} className="shrink-0 mt-1 text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
            <a
              href={`https://www.${b.domain}/blog`}
              target="_blank"
              rel="noreferrer"
              data-testid={`blog-all-${b.domain.replace(/\./g, "-")}`}
              className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[#D4AF37] hover:gap-3 transition-all duration-300"
            >
              كل المقالات
              <ArrowLeft size={15} />
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
